<!--  -->
<template>
	<div class="content">
		<cx-head v-if="windowWidth <= 768" />
		<img class="img" src="../../static/img/index/img_max.jpg" v-if="windowWidth > 768"/>
		<img class="img" src="../../static/img/index/img_min.jpg" v-else/>
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import api from '../api/api.js';
import cxHead from '@/components/cx-head.vue';
export default {
	//import引入的组件需要注入到对象中才能使用
	components: {
		cxHead,
	},
	name: 'async',
	metaInfo() {
		return {
			title: this.pageName, // set a title
			meta: [
				{
					// set meta
					name: 'keyWords',
					content: this.SeoKeyword,
				},
				{
					name: 'description',
					content: this.SeoDescription,
				},
			],
		};
	},
	data() {
		//这里存放数据
		return {
			windowWidth: window.innerWidth,
			loading: true,
			pageName: 'loading',
			SeoKeyword: '',
			SeoDescription: '',
			i: 0,
		

			title: '',
			date: '',
			textHtml: '',
			pageId: '',
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {},
	//方法集合
	methods: {
		getSiteData() {
			//获取seo关键字
			let that = this;
			that.$axios
				.post(api.GetSiteData, {})
				.then(function (response) {
					// console.log('seo优化', response);
					let data = response.data;
					that.pageName = data.Title ? data.Title : '约你游·一站式房车旅游综合服务平台';
					that.SeoKeyword = data.SeoKeyword ? data.SeoKeyword : '约你游·一站式房车旅游综合服务平台';
					that.SeoDescription = data.SeoDescription
						? data.SeoDescription
						: '约你游·一站式房车旅游综合服务平台';
				})
				.catch(function (error) {
					console.log(error);
				});
		},
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		// console.log(title);
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {
		this.getSiteData();
	},
	beforeCreate() { }, //生命周期 - 创建之前
	beforeMount() { }, //生命周期 - 挂载之前
	beforeUpdate() { }, //生命周期 - 更新之前
	updated() { }, //生命周期 - 更新之后
	beforeDestroy() { }, //生命周期 - 销毁之前
	destroyed() { }, //生命周期 - 销毁完成
	activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.content {
	padding-bottom: 30px;
}


@media (min-width: 768px) {
	.img{
		width: 100%;
		max-width: 1200px;
		margin: 0 auto;
	}
}


@media (max-width: 768px) {
	.img{
		width: 100%;
		margin: 0 auto;
	}
}


</style>



// WEBPACK FOOTER //
// src/page/activity.vue